import { Box, LinearProgress, Typography } from "@mui/material";

export function SimilarityCell({ value }: { value: number | null }) {
  if (value == null) return null;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
      <Box sx={{ flexGrow: 1 }}>
        <LinearProgress variant="determinate" value={value} sx={{ height: 6, borderRadius: 3 }} />
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ minWidth: 32 }}>
        {value}%
      </Typography>
    </Box>
  );
}
